import { Link } from 'react-router-dom';
import { Card, CardTitle, CardDescription } from '@/components/ui/card';

export default function NotFound() {
  return (
    <Card>
      <CardTitle>Not found</CardTitle>
      <CardDescription className="mt-2">
        This page doesn't exist. <Link to="/" className="text-accent hover:underline">Back to Brief →</Link>
      </CardDescription>
    </Card>
  );
}
